/**
 * Key for identifying notification uniquely.
 */
export const notificationIdentity = 'notificationKey';

export const NOONA_PAGE_NOTIFICATION = 'NOONA_PAGE_NOTIFICATION';

export const NOONA_NAVIGATION_SERVICES_NOTIFICATION =
  'NOONA_NAVIGATION_SERVICES_NOTIFICATION';

export const LIBREVIEW_PAGE_NOTIFICATION = 'LIBREVIEW_PAGE_NOTIFICATION';

export const LIBREVIEW_SERVICES_NOTIFICATION =
  'LIBREVIEW_SERVICES_NOTIFICATION';

export const TAYSPOLKU_PAGE_NOTIFICATION = 'TAYSPOLKU_PAGE_NOTIFICATION';

export const TAYSPOLKU_SERVICES_NOTIFICATION =
  'TAYSPOLKU_SERVICES_NOTIFICATION';

export const QUESTIONNAIRE_PAGE_NOTIFICATION =
  'QUESTIONNAIRE_PAGE_NOTIFICATION';

export const FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION =
  'FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION';

export const AIVA_QUESTIONNAIRE_COMPLETED_NOTIFICATION =
  'AIVA_QUESTIONNAIRE_COMPLETED_NOTIFICATION';

export const LABORATORY_PAGE_NOTIFICATION = 'LABORATORY_PAGE_NOTIFICATION';

export const COXAPOLKU_PAGE_NOTIFICATION = 'COXAPOLKU_PAGE_NOTIFICATION';

export const COXAPOLKU_SERVICES_NOTIFICATION =
  'COXAPOLKU_SERVICES_NOTIFICATION';
